import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanMatch, GuardResult, MaybeAsync, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { BooxSessionService } from '../service';
import { BOOX_ROUTES, BooxRoutesToken } from '../token';


@Injectable({
    providedIn: 'root'
})
export class BooxAdminGuard implements CanActivate, CanActivateChild, CanMatch {

    router: Router;
    sessionSrv: BooxSessionService;
    routes: BooxRoutesToken;

    constructor() {
        this.router = inject(Router);
        this.sessionSrv = inject(BooxSessionService);
        this.routes = inject(BOOX_ROUTES);
    }

    private _canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        
        if(this.sessionSrv.isAuthenticated && this.sessionSrv.isAdmin) return true;
        if(this.routes.home) this.router.navigate(this.routes.home);
        return false;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._canActivate(route, state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this._canActivate(childRoute, state);
    }

    canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {
        return false;
    }
}
